import { Buffer } from 'buffer';
var createBuffer = Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow ? Buffer.from : // support for Node < 5.10
function (val) {
  return new Buffer(val);
};
export default createBuffer;